module.exports = __webpack_public_path__ + "img/958-b4a3e6.png";